import '../styles/home.css';
import Hero from '../components/Hero';
import MinCarousel from '../components/MinCarousel';
// import { Fade } from 'react-reveal';
import {
    LEFT_TEXT,
    MASONRY_TEXT,
    MASONRY_TITLE,
    RIGHT_TEXT,
    TESTIMONIALS
} from '../constants';

const Fade = require('react-reveal/Fade');
const Home = () => {

    return (
        <div className="container-fluid px-0">
            <div className="container pt-3">
                <div className="row">
                    <div className="col">
                        <Fade distance='100%' duration={1500} delay={200}>
                            <Hero />
                        </Fade>
                    </div>
                </div>
            </div>

            {/* Start Carousel Content */}
            <div className="home-carousel">
                {/* <img src="/assets/images/living-room-1.jpg" alt="" /> */}
                <MinCarousel />
            </div>
            {/* End Carousel Content */}



            <div className="container">
                <div className="row hero ">
                    <div className="col-12 col-md-6 d-flex justify-content-center justify-content-md-start">
                        <Fade delay={1000} duration={2000}>
                            <p className="light-chocolate heading-1 multi-line">
                                {LEFT_TEXT}
                            </p>
                        </Fade>
                    </div>
                    <div className="col-12 col-md-6 d-flex justify-content-center justify-content-md-start">
                        <Fade delay={1000} duration={2000}>
                            <p className="light-chocolate heading-1 multi-line text-center text-md-start">
                                {RIGHT_TEXT}
                            </p>
                        </Fade>
                    </div>
                </div>
            </div>

            {/* Start horizontal grid */}
            <div className="row horizontal-grid g-0">
                <Fade left distance="100%">
                    <div className="horizontal-grid-col col-xs-6 col-md-6 col-lg-3">
                        <img src="/assets/images/vertical-grid/img1.jpg" alt="" />
                    </div>
                </Fade>

                <Fade left distance='100%' delay={500}>
                    <div className="horizontal-grid-col col-xs-6 col-md-6 col-lg-3">
                        <img src="/assets/images/vertical-grid/img2.jpg" alt="" />
                    </div>
                </Fade>

                <Fade right distance='100%' delay={500}>
                    <div className="horizontal-grid-col col-xs-6 col-md-6 col-lg-3">
                        <img src="/assets/images/vertical-grid/img3.jpg" alt="" />
                    </div>
                </Fade>

                <Fade right distance='100%'>
                    <div className="horizontal-grid-col col-xs-6 col-md-6 col-lg-3">
                        <img src="/assets/images/vertical-grid/img4.jpg" alt="" />
                    </div>
                </Fade>

            </div>
            {/* End horizontal grid */}

            <div className="container">
                <div className="row">
                    <div className="col hero-sub d-flex justify-content-center">
                        <Fade duration={1500} delay={500}>
                            <p className="light-chocolate heading-1"> {MASONRY_TITLE} </p>
                        </Fade>
                    </div>
                </div>
            </div>

            {/* Start Test Masonry Grid */}
            <Fade duration={1500} delay={500}>
                <div className="mytext d-lg-none d-flex justify-content-center pb-5">
                    <p className="masonry-hero content-2" align="center">
                        {MASONRY_TEXT}
                    </p>
                </div>
            </Fade>

            <div className="test-masonry">
                <div className="row no-gutters no-border mx-0">

                    {/* Start Left Hand Side Grid */}
                    <Fade left distance='100%' duration={1500}>
                        <div className="lhs-col col-lg-3 col-sm-6">
                            <img className="grid-img" src="/assets/images/home-masonry-grid/img-long.jpg" alt="" />
                        </div>
                    </Fade>
                    <div className="lhs-col col-lg-3 col-sm-6">
                        {/* <div className="row mx-0"> */}
                        <Fade left distance='100%' duration={1000} delay={500}>
                            <div className="lhs-col-mid col-sm-6">
                                <img className="grid-img" src="/assets/images/home-masonry-grid/img1.jpg" alt="" />
                            </div>
                        </Fade>
                        <Fade left distance='100%' duration={1000} delay={800}>
                            <div className="lhs-col-mid col-sm-6">
                                <img className="grid-img" src="/assets/images/home-masonry-grid/img2.jpg" alt="" />
                            </div>
                        </Fade>
                        {/* </div> */}
                    </div>
                    {/* End Left Hand Side Grid */}

                    {/* Start Right Hand Side Grid */}
                    <div className="rhs-col col-lg-6 col-12 ">
                        <div className="row rhs-text-box d-none d-lg-flex mx-0">
                            <Fade right distance='100%' duration={1500} delay={500}>
                                <div className=" col-12 d-flex align-items-center justify-content-center">
                                    <p className="light-chocolate masonry-hero content-2 multi-line">
                                        {MASONRY_TEXT}
                                    </p>
                                </div>
                            </Fade>
                        </div>

                        <div className="row mx-0">
                            <Fade right distance='100%' duration={1000} delay={500}>
                                <div className="col-sm-6 bottom-right-corner">
                                    <img className="grid-img" src="/assets/images/home-masonry-grid/img3.jpg" alt="" />
                                </div>
                            </Fade>
                            <Fade right distance='100%' duration={1000} delay={800}>
                                <div className="col-sm-6 bottom-right-corner">
                                    <img className="grid-img" src="/assets/images/home-masonry-grid/img4.jpg" alt="" />
                                </div>
                            </Fade>
                        </div>
                    </div>
                    {/* End Right Hand Side Grid */}

                </div>
            </div> {/* End Test Masonry Grid */}

            {/* Start Testimonials */}
            <div className="container">
                <div className="row">
                    <div className="col hero-sub d-flex justify-content-center"
                        style={{ paddingBottom: '25px' }}>
                        <Fade duration={1500} delay={500}>
                            <p className="heading-1"> {TESTIMONIALS} </p>
                        </Fade>
                    </div>
                </div>
                <Fade duration={1500} delay={500}>
                    <div className="row no-gutters no-border mx-0 align-items-center justify-content-evenly">
                        <div className="p-0 col-3 text-center">
                            {/* <div className="testimonial-img-box"> */}
                            <img className='img-fluid' src="/assets/icons/kb-logo.svg" alt="" />
                            {/* </div> */}
                        </div>
                        <div className="p-0 col-3 text-center">
                            {/* <div className="testimonial-img-box"> */}
                            <img className="jeevandeep img-fluid" src="/assets/icons/jeevandeep-frame.svg" alt="" />
                            {/* </div> */}
                        </div>
                        <div className="p-0 col-3 text-center">
                            {/* <div className="testimonial-img-box"> */}
                            <img className='img-fluid' src="/assets/icons/hg-logo.svg" alt="" />
                            {/* </div> */}
                        </div>
                    </div>
                </Fade>
            </div>
            {/* End Testimonials */}

        </div > /* Main Div */
    );
}

export default Home;